import { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { login } from '../../api/auth'
import PasswordField from '../../components/PasswordField'
import AuthPage, { AuthField } from '../../components/PublicLayout'
import { parseCompanyId, rememberCompanyId, rememberedCompanyId } from '../../utils/companyId'

export default function Login({ onSignedIn }) {
  const nav = useNavigate()
  const location = useLocation()
  // Filled in from the last sign-in on this device, so most people skip it.
  const [companyId, setCompanyId] = useState(rememberedCompanyId)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')
  const params = new URLSearchParams(location.search)
  const timeoutNotice = params.get('reason') === 'timeout'

  const submit = async (e) => {
    e && e.preventDefault()
    const company = parseCompanyId(companyId)
    if (company.error) { setErr(company.error); return }
    if (!username || !password) { setErr('Enter your username and password.'); return }
    setBusy(true); setErr('')
    try {
      const u = await login(username, password, company.id)
      rememberCompanyId(company.id)
      onSignedIn && onSignedIn(u)
      const next = new URLSearchParams(location.search).get('next') || '/dashboard'
      nav(next, { replace: true })
    } catch (e) {
      setErr(String(e?.response?.data?.error || e?.response?.data?.message || e?.message || e))
    } finally { setBusy(false) }
  }

  return (
    <AuthPage
      title="Welcome back"
      intro="Sign in to your company on ASYS Retail."
      top={<Link className="pub-btn pub-btn-dark" to="/signup">Get started</Link>}
      foot={<>New to ASYS Retail? <Link to="/signup">Create your company</Link></>}
    >
      {timeoutNotice && <p className="pub-notice">You were signed out after a while without activity. Sign in again to carry on.</p>}
      <form onSubmit={submit} className="pub-form" noValidate>
        <AuthField id="login-company" label="Company ID" hint="The number your welcome email calls Tenant ID. It’s also under Settings, Company.">
          <input id="login-company" value={companyId} onChange={(e) => setCompanyId(e.target.value)} inputMode="numeric" autoComplete="organization" autoFocus={!companyId} />
        </AuthField>
        <AuthField id="login-username" label="Username">
          <input id="login-username" value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" autoFocus={!!companyId} />
        </AuthField>
        <AuthField id="login-password" label="Password">
          <PasswordField id="login-password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
        </AuthField>
        {err && <p className="pub-error" role="alert">{err}</p>}
        <button type="submit" className="pub-btn pub-btn-primary pub-btn-block" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
        <p className="pub-center"><Link to="/forgot-password">Forgot your password?</Link></p>
      </form>
    </AuthPage>
  )
}
